module.exports = __webpack_public_path__ + "static/media/jawLeft.fbd4741c.obj";